import React from 'react';
import { Overline } from '../../typography';
export const WeekDay = (day) => {
    return React.createElement(Overline, null, day.slice(0, 3));
};
